import Notification from "@/components/Notification";
import Vue from "vue"

const Notif = Vue.extend(Notification)

export default (text, type) => {
  const notification = new Notif({
    propsData: {
      text,
      type
    }
  })
  notification.$mount()
  document.getElementById("app").appendChild(notification.$el)
}